const updates = [
  { date: '07-30', title: '《暗夜追踪》第12集更新上线', tag: '剧集更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-30', title: '动作大片《极限营救》首发上线', tag: '新片首发', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-29', title: '《锦绣浮生》全集打包上线', tag: '全集上线', tagColor: 'bg-green-100 text-green-700' },
  { date: '07-29', title: '《心动频率》第8集同步更新', tag: '剧集更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '纪录片《地球脉动III》完整上线', tag: '纪录片', tagColor: 'bg-blue-100 text-blue-700' },
  { date: '07-28', title: '热门综艺《喜剧大会》新一期', tag: '综艺更新', tagColor: 'bg-amber-100 text-amber-700' },
  { date: '07-27', title: '国漫《灵笼》第二季重磅回归', tag: '动漫更新', tagColor: 'bg-purple-100 text-purple-700' },
  { date: '07-27', title: '悬疑片单专题页面上线', tag: '专题', tagColor: 'bg-secondary-100 text-secondary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          最新动态
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">每日影视更新速递，不错过任何精彩</p>
        <div className="max-w-2xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="relative flex items-start gap-4 pb-5 last:pb-0"
            >
              <div className="flex flex-col items-center shrink-0">
                <span className="text-xs font-label font-semibold text-foreground-700 bg-background-200/70 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.date}
                </span>
                {idx < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-300 mt-2 min-h-[16px]"></div>
                )}
              </div>
              <div className="flex-1 min-w-0 flex flex-wrap items-center gap-2">
                <span className={`px-2 py-0.5 rounded-md text-xs font-label font-semibold ${item.tagColor}`}>
                  {item.tag}
                </span>
                <h3 className="text-sm font-body text-foreground-800 leading-snug">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}